var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 92,
    viewBox: "0 0 80 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11716_21798)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.6496,
    cy: 42.6843,
    rx: 29.3129,
    ry: 29.3129,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.3431C0 12.6118 0.620408 12.0023 1.41224 11.9795C1.65714 11.9719 25.2245 11.1796 39.0367 0.346647C39.6082 -0.110439 40.449 -0.118057 41.0204 0.339029L41.0286 0.346647C54.8408 11.1872 78.351 11.9795 78.5878 11.9871C79.3714 12.0099 80 12.6118 80 13.3507V13.4574C80 32.2893 76.702 58.6174 60.4408 77.0608C50.5959 88.229 40.8408 91.1696 40.4245 91.2914L39.9837 91.4286L39.5265 91.2914C39.1102 91.1696 29.4122 88.229 19.5673 77.0608C3.29796 58.6098 0 32.2893 0 13.4498V13.3431ZM27.2322 30.2322C28.2085 29.2559 29.7915 29.2559 30.7678 30.2322L40 39.4645L49.2322 30.2322C50.2085 29.2559 51.7915 29.2559 52.7678 30.2322C53.7441 31.2085 53.7441 32.7915 52.7678 33.7678L43.5355 43L52.7678 52.2322C53.7441 53.2085 53.7441 54.7915 52.7678 55.7678C51.7915 56.7441 50.2085 56.7441 49.2322 55.7678L40 46.5355L30.7678 55.7678C29.7915 56.7441 28.2085 56.7441 27.2322 55.7678C26.2559 54.7915 26.2559 53.2085 27.2322 52.2322L36.4645 43L27.2322 33.7678C26.2559 32.7915 26.2559 31.2085 27.2322 30.2322Z",
    fill: "#F2E5B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11716_21798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 91.4293,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.041e0ef73b684692197c1d0362db3031.svg";
export { ForwardRef as ReactComponent };